module.exports = __webpack_public_path__ + "static/img/pingjie5.62ce5d62.png";